import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import ProductCard from '../components/ProductCard';
const API_BASE_URL = '';

const DEFAULT_SETTINGS = {
  hero_subtext: 'Picadas premium artesanales armadas a tu medida con productos frescos de campo',
  tradition_title: 'Picadas Artesanales a Tu Medida',
  tradition_text: 'En Picadas del Campo creemos que cada momento merece una picada perfecta. Por eso te damos la libertad de elegir exactamente lo que querés: seleccion tus quesos, fiambres, conservas y acompañamientos favoritos, y nosotros armamos tu picada ideal en el momento, con productos frescos artesanales de campo.',
  process_title: 'Así Armamos Tu Picada',
};

const HomePage = () => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [settingsRes, productsRes] = await Promise.all([
          fetch(`${API_BASE_URL}/api/settings`).catch(() => null),
          fetch(`${API_BASE_URL}/api/products?featured=true&limit=4`).catch(() => null),
        ]);
        if (settingsRes?.ok) {
          const data = await settingsRes.json();
          setSettings(prev => ({ ...prev, ...data }));
        }
        if (productsRes?.ok) {
          const data = await productsRes.json();
          setFeaturedProducts(data.products || data || []);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <Hero settings={settings} />

      {/* Cómo Funciona */}
      <section className="py-16 md:py-24 bg-[#EFE1C4]">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] text-center mb-4">
            {settings.tradition_title || DEFAULT_SETTINGS.tradition_title}
          </h2>
          <p className="text-[#5a3e2b] text-center max-w-3xl mx-auto mb-12 leading-relaxed">
            {settings.tradition_text || DEFAULT_SETTINGS.tradition_text}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white/60 rounded-2xl p-8 text-center shadow-sm">
              <div className="text-4xl mb-4">1</div>
              <h3 className="text-xl font-bold text-[#2C1810] mb-3">Elegí tus productos</h3>
              <p className="text-[#5a3e2b]">Explorá nuestra selección de quesos, fiambres, conservas, frutos secos y más. Elegí los que más te gusten para armar tu picada perfecta.</p>
            </div>
            <div className="bg-white/60 rounded-2xl p-8 text-center shadow-sm">
              <div className="text-4xl mb-4">2</div>
              <h3 className="text-xl font-bold text-[#2C1810] mb-3">Armamos en el momento</h3>
              <p className="text-[#5a3e2b]">Tu picada se arma fresca en el momento del pedido sobre una elegante tablita negra, cuidando cada detalle de presentación.</p>
            </div>
            <div className="bg-white/60 rounded-2xl p-8 text-center shadow-sm">
              <div className="text-4xl mb-4">3</div>
              <h3 className="text-xl font-bold text-[#2C1810] mb-3">Envasada al vacío</h3>
              <p className="text-[#5a3e2b]">Cada picada se envasa al vacío para mantener la frescura y calidad de los productos artesanales hasta que la disfrutes.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Productos Destacados */}
      {featuredProducts.length > 0 && (
        <section className="py-16 md:py-24 bg-[#f5ead4]">
          <div className="max-w-6xl mx-auto px-4">
            <h2 className="text-3xl md:text-4xl font-bold text-[#2C1810] text-center mb-4">
              Productos Para Tu Picada
            </h2>
            <p className="text-[#5a3e2b] text-center max-w-2xl mx-auto mb-12">
              Seleccioná entre nuestra variedad de productos artesanales frescos de campo
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {featuredProducts.slice(0, 4).map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
            <div className="text-center mt-10">
              <Link to="/productos" className="bg-[#2C1810] text-[#EFE1C4] px-8 py-3 rounded-lg font-semibold hover:bg-[#3d2419] transition-colors">
                Ver todos los productos
              </Link>
            </div>
          </div>
        </section>
      )}

      {/* Tablita Negra - Presentacion */}
      <section className="py-16 md:py-24 bg-[#1a0f0a]">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-[#EFE1C4] text-center mb-4">
            La Tablita Negra
          </h2>
          <p className="text-[#D4A574] text-center max-w-2xl mx-auto mb-12 text-lg">
            Nuestro sello distintivo
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#D4A574] rounded-full flex items-center justify-center text-[#1a0f0a] font-bold flex-shrink-0">1</div>
                  <div>
                    <h3 className="text-[#EFE1C4] font-semibold text-lg mb-1">Tablita artesanal negra</h3>
                    <p className="text-[#b8a080]">Cada picada se presenta sobre una elegante tabla negra que realza los colores y texturas de los productos.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#D4A574] rounded-full flex items-center justify-center text-[#1a0f0a] font-bold flex-shrink-0">2</div>
                  <div>
                    <h3 className="text-[#EFE1C4] font-semibold text-lg mb-1">Envasado al vacío</h3>
                    <p className="text-[#b8a080]">Sellamos al vacío para preservar la frescura, el sabor y la calidad de cada producto artesanal.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-[#D4A574] rounded-full flex items-center justify-center text-[#1a0f0a] font-bold flex-shrink-0">3</div>
                  <div>
                    <h3 className="text-[#EFE1C4] font-semibold text-lg mb-1">Armada en el momento</h3>
                    <p className="text-[#b8a080]">No armamos picadas de antemano. Cada una se prepara fresca cuando hacés tu pedido, garantizando máxima calidad.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#2C1810] rounded-2xl p-8 text-center">
              <div className="text-6xl mb-4"></div>
              <h3 className="text-[#EFE1C4] text-xl font-bold mb-2">Tu picada, tu elección</h3>
              <p className="text-[#b8a080] mb-6">Combiná quesos, fiambres, conservas, frutos secos y más. Sin límites, sin menús fijos.</p>
              <Link to="/presentacion" className="inline-block bg-[#D4A574] text-[#1a0f0a] px-6 py-3 rounded-lg font-semibold hover:bg-[#c49564] transition-colors">
                Conocé nuestras picadas
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 md:py-20 bg-[#2C1810]">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#EFE1C4] mb-4">
            Armá tu picada perfecta
          </h2>
          <p className="text-[#b8a080] text-lg mb-8 max-w-2xl mx-auto">
            Productos frescos artesanales de campo, armados a tu medida sobre tablita negra y envasados al vacío.
          </p>
          <Link to="/productos" className="bg-[#D4A574] text-[#1a0f0a] px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#c49564] transition-colors">
            Empezar a armar mi picada
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
